import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { CREATE_CHAUFFEUR_V3, CREATE_CHAUFFEUR_V3_SUCCESS, CREATE_CHAUFFEUR_V3_ERROR } from './../../../actionType.js';
import apiCall from '../../../apiCall';
import cogoToast from 'cogo-toast';

function* createChauffeurV3({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/vendor/chauffeur/create`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: CREATE_CHAUFFEUR_V3_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: CREATE_CHAUFFEUR_V3_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_CHAUFFEUR_V3_ERROR, payload: error });
  }
}

export function* watchcreateChauffeurV3() {
  yield takeEvery(CREATE_CHAUFFEUR_V3, createChauffeurV3);
}

function* createChauffeurV3Saga() {
  yield all([fork(watchcreateChauffeurV3)]);
}

export default createChauffeurV3Saga;
